module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.forecastWindow ? 'col-lg-6' : 'col-lg-3'
  }, [_c('div', {
    staticClass: "SectionTitle"
  }, [_vm._v("general dates")]), _vm._v(" "), _c('div', {
    staticClass: "normal-text"
  }, [_vm._v("\n            Ref date : "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.formDate(_vm.forecast.refDate)))]), _c('br'), _vm._v("\n            Availability date : "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.forecast.availabilityDate ? _vm.formDate(_vm.forecast.availabilityDate) : "-"))]), _vm._v(" "), _c('br'), _vm._v("\n            Launch date : "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.forecast.launchDate ? _vm.formDate(_vm.forecast.launchDate) : "-"))]), _vm._v(" "), _c('br'), _vm._v("\n            Animation Campaign : " + _vm._s(_vm.forecast.campaign.name) + " "), _c('br'), _vm._v("\n            Preseries date : "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.forecast.preseriesDate ? _vm.formDate(_vm.forecast.preseriesDate) : "-"))]), _vm._v(" "), _c('br'), _vm._v("\n            End of campaign : "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.forecast.endOfCampaign ? _vm.formDate(_vm.forecast.endOfCampaign) : "-"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                Recurrence : "), _c('span', {
    staticClass: "bold normal-text"
  }, [_vm._v(_vm._s(_vm.forecast.recurrenceAmount) + " months")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 d-flex align-items-end justify-content-end"
  }, [_c('History', {
    attrs: {
      "object": _vm.forecast,
      "object-type": _vm.OBJECT_TYPE.FORECASTS,
      "is-dark": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.useForecastDatesForZone) ? _c('div', {
    staticClass: "SectionTitle"
  }, [_vm._v("forecast manager dates")]) : _c('div', {
    staticClass: "SectionTitle"
  }, [_vm._v("zone manager dates")]), _vm._v(" "), _c('div', {
    staticClass: "normal-text"
  }, [_vm._v("\n            Start Date: "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.formDate(_vm.startDateToShow)))]), _vm._v(" "), _c('br'), _vm._v("\n            End Date: "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.formDate(_vm.endDateToShow)))]), _vm._v(" "), _c('br')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67fdc3ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/general/DateInfosDetail.vue
// module id = 3240
// module chunks = 0